import { defineStore } from 'pinia'
import { msCourseAPI } from '../services/api'

export const useCategoryStore = defineStore('category', {
  state: () => ({
    categories: [],
    loading: false,
    error: null
  }),

  actions: {
    async fetchCategories() {
      this.loading = true
      this.error = null
      try {
        const response = await msCourseAPI.listCategories()
        this.categories = response.data || []
      } catch (err) {
        this.error = '獲取分類失敗: ' + err.message
        console.error('獲取分類失敗:', err)
      } finally {
        this.loading = false
      }
    }
  },

  getters: {
    getCategoriesList: (state) => state.categories,
    isLoading: (state) => state.loading,
    getError: (state) => state.error
  }
})
